import { PoOperationCompletionModel } from "./po-operation-completion.model";


export class PoSummaryForOperationModel {
    poNumber: string;
    style: string;
    schedule: string;
    buyer: string;
    destination: string;
    deliveryDate: string;
    orderQty: number;
    operationsCompletionInfo: PoOperationCompletionModel[];

    constructor(poNumber: string, style: string, schedule: string, buyer: string, destination: string, deliveryDate: string, orderQty: number, operationsCompletionInfo: PoOperationCompletionModel[]) {
        this.poNumber = poNumber;
        this.schedule = schedule;
        this.style = style;
        this.buyer = buyer;
        this.deliveryDate = deliveryDate;
        this.destination = destination;
        this.orderQty = orderQty;
        this.operationsCompletionInfo = operationsCompletionInfo;
    }
}

